import api from "@services/apiList";
import { ResponseType } from "../../../Types/ServicesType/servicesType";
import {  MasterDataType, MasterTableDataType, SaveResponseType, SearchParamsType } from "./types";
import { getConstants } from "@utilifiles/methods/storage/storage";
import instance from "@services/services";
const { clinicId, createdById } = getConstants()
const {MastersApi} = api
export const getMastersTableData = async (params:SearchParamsType & {codetype :string}):Promise<ResponseType<{items:MasterTableDataType[],totalcount:number}>>=>{
    const result = await instance.post(params.codetype === "INTERNAL" ? `${MastersApi.getAllCptv2}`: `${MastersApi.getAllCpt}` ,{...params,clinicId});
    return result.data;
}

export const uploadFile = async (file:File):Promise<ResponseType<string>>=>{
    const formData = new FormData();
    formData.append("clinicId", `${clinicId}`);
    formData.append("createdById", `${createdById}`);
    formData.append("file", file);
    const result = await instance.post(`${MastersApi.uploadCpt}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return result.data;
}


export const saveMasterData = async ({params,codetype}:{params:MasterDataType[],codetype:string}):Promise<ResponseType<SaveResponseType>>=>{
    const result = await instance.post(codetype == "INTERNAL" ? `${MastersApi.saveCptv2}` : `${MastersApi.saveCpt}`,params);
    return result.data;
}

